"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const components_1 = require("@/common/components");
const _1 = require(".");
function default_1() {
    const currentLang = (0, detect_utils_1.currentLanguage)();
    const deliveryRegion = (0, react_redux_1.useSelector)((state) => state.roomData.delivery_region);
    const countries = (0, functions_1.getCountryObj)(currentLang);
    const currentCountryObj = countries.find(obj => obj.value === deliveryRegion);
    const currentCountryName = (currentCountryObj === null || currentCountryObj === void 0 ? void 0 : currentCountryObj.name) || '';
    const currentCountryCode = (currentCountryObj === null || currentCountryObj === void 0 ? void 0 : currentCountryObj.value) || '';
    const deliveryType = (0, react_redux_1.useSelector)((state) => state.deliveryType);
    const isCustomDelivery = deliveryType === '6';
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '14px',
            padding: '16px 0',
            marginBottom: '10px',
        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '6px', padding: '0 16px' } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle3 gray-80" }, { children: `${t('P-으로 배송')}${currentCountryName}${t('S-으로 배송')}` })), (0, jsx_runtime_1.jsx)(components_1.RoundImage, { size: 22, altHeight: "100%", src: `https://flagcdn.com/w20/${currentCountryCode.toLowerCase()}.webp`, srcSet: `https://flagcdn.com/w40/${currentCountryCode.toLowerCase()}.webp 2x`, additionalCss: {
                            display: 'flex',
                            alignItems: 'center',
                            minHeight: '16px',
                            margin: '0 1px',
                        }, altAfterImgWrapperCss: { borderRadius: '2px' } })] })), isCustomDelivery ? (0, jsx_runtime_1.jsx)(_1.CustomDelivery, {}) : (0, jsx_runtime_1.jsx)(_1.DeliveryInfo, {})] })));
}
exports.default = default_1;
